import { Affix, Button, Card } from "antd";
import Header from "components/Common/Header";
import { DailyFinishingLinePlanContext } from "context/DailyFinishingLinePlanContext";
import { useContext } from "react";
import { useNavigate } from "react-router";
import DailyLinePlanForm from "../DailyLinePlanForm";

export default function DailyFinishingLinePlanEdit() {
  const { form } = useContext(DailyFinishingLinePlanContext);
  const navigate = useNavigate();
  return (
    <div>
      <Affix offsetTop={0}>
        <Card className="p-fixed">
          <Header
            title="Edit Daily Finishing Line Plan"
            subTitle=""
            addLink="/"
            addText="Submit"
            actions={[
              <Affix offsetTop={20}>
                <Button
                  size="small"
                  key={1}
                  danger
                  onClick={() =>
                    navigate("/digitalization/daily-finishing-line-plan")
                  }
                >
                  Discard
                </Button>
              </Affix>,
              <Affix offsetTop={20}>
                <Button
                  size="small"
                  key={2}
                  type="primary"
                  onClick={() => form?.submit()}
                >
                  Update
                </Button>
              </Affix>,
            ]}
          ></Header>
        </Card>
      </Affix>
      <DailyLinePlanForm />
    </div>
  );
}
